import {Component, DestroyRef, inject, Input, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {SupplierOutletService} from "../../../app-shared/services/supplier-outlet.service";
import {CartService} from "../../../app-shared/services/cart.service";
import {environment} from "../../../../environments/environment";
import {allUserPermissions} from "../../../app-shared/models/user-phermissions.model";
import {AuthService, CustomFunctions, MainUserService, PermissionsService, UserLoginType} from "../../../app-shared";
import {UserMenu} from "../../../profile/profile-shared/models/outlet.model";
import {SupplierPluginsNames} from "../../../app-shared/models/supplier-outlet.model";
import {ReportType} from "../../../reports/reports.model";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
  standalone: false
})

export class SubHeaderComponent implements OnInit {

  @Input() isCart: boolean;
  @Input() mobile: boolean;
  @Input() disableChangeUser: boolean;

  IsOpenModal = false;
  creditLimit: number = null;
  isTooltipVisible = false;
  readonly allPermissions = allUserPermissions;
  CustomFunction = CustomFunctions;
  userLogin: string;
  isLoginSuperBusinessAdminOrBusinessAdmin: boolean;

  isShowChangeOutlet = false;
  private readonly destroyRef = inject(DestroyRef);

  constructor(private router: Router,
              private supplierOutletService: SupplierOutletService,
              private cartService: CartService,
              public permissionsService: PermissionsService,
              private authService: AuthService,
              private mainUserService: MainUserService) {
  }

  ngOnInit() {
    this.getCreditLimit();
    this.loginSuperBusinessAdminOrBusinessAdmin();
    this.changeUser();
  }

  loginSuperBusinessAdminOrBusinessAdmin() {
    this.authService.isLoginSuperBusinessAdminOrBusinessAdmin
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.isLoginSuperBusinessAdminOrBusinessAdmin = res;
      });
  }

  changeUser() {
    const loginType = this.authService.getTypeLoginRules();
    if (loginType === UserLoginType.Phone) {
      this.userLogin = CustomFunctions.formatPhoneNumberLabel(
        this.mainUserService.getUserData().login
      );
    } else {
      this.userLogin = this.mainUserService.getUserData().login;
    }
  }

  getCreditLimit() {
    // set default value if exist credit limit obj by supplier and outlet
    if (this.supplierOutletService.isUserSelectedSupplierAndOutlet()) {
      const supplierAndOutlet = this.supplierOutletService.getUserSelectedSupplierAndOutlet();
      this.creditLimit = this.cartService.getCreditLimitBySupplierAndOutlet(supplierAndOutlet.supplierId, supplierAndOutlet.outletId);
    }
    // check change credit limit
    this.cartService.creditLimitSubject
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(limit => {
        this.creditLimit = limit;
      })
  }

  showModuleForSubheader() {
    if (!!environment['moduleInHeader']) {
      return environment['moduleInHeader'];
    }
    return null;
  }

  showTooltip(isShow = true) {
    this.isTooltipVisible = isShow;
  }

  goToDebt() {
    if (!!environment['goToAnalyticsDebt']) {
      void this.router.navigate(['reports'], {
        queryParams: {reportId: ReportType.debt}
      })
      return;
    }
    void this.router.navigate(['user/profile'], {
      queryParams: {userMenu: UserMenu.Debt}
    })
  }

  toggleOpenModal(): void {
    this.IsOpenModal = !this.IsOpenModal;
  }

  outsideClick(): void {
    this.IsOpenModal = false;
  }

  isShowCreditLimit(): boolean {
    return this.CustomFunction.checkIfNumeric(this.creditLimit)
      && this.permissionsService.isAvailableForUser(this.allPermissions.isShowDebt)
      && this.isCart
  }

  isShowDebt() {
    return this.permissionsService.isAvailableForUser(allUserPermissions.isShowDebt) &&
      this.supplierOutletService.getIsPluginEnabled(SupplierPluginsNames.IsDebit) &&
      !this.supplierOutletService.getIsPluginEnabled(SupplierPluginsNames.CreditLimitEnabled)
  }

}
